export class Color {
  r: number;
  g: number;
  b: number;
  
  constructor(init: any) {
    this.r = (init.r || 0);
    this.g = (init.g || 0);
    this.b = (init.b || 0);    
  }
}
